import * as React from 'react';

import { css } from '@emotion/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { VStackProps } from '@rtkwlf/fenrir-react';
import { colors, Text, VStack } from '@rtkwlf/fenrir-react';
import { faSpinnerThird } from '@rtkwlf/pro-regular-svg-icons/faSpinnerThird';
import { useTranslation } from 'react-i18next';

import { useMediaQuery } from '@packages/hooks/use-media-query';

interface LoaderProps extends Omit<VStackProps, 'css' | 'children'> {
  withMask?: boolean;
  message?: string;
}

const maskStyling = css({
  backgroundColor: `rgb(${colors.background.widget.default})`,
  bottom: 0,
  left: 0,
  opacity: 0.85,
  position: 'absolute',
  right: 0,
  top: 0,
});

export const Loader: React.FC<LoaderProps> = ({
  withMask,
  message,
  ...rest
}) => {
  const { t } = useTranslation('ui');
  const isReducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');

  return (
    <VStack
      width="full"
      gap="small"
      paddingY="large"
      paddingX="zero"
      alignItems="center"
      justifyContent="center"
      css={withMask ? maskStyling : undefined}
      {...rest}
    >
      <FontAwesomeIcon
        icon={faSpinnerThird}
        spin={!isReducedMotion}
        size="2x"
        color={`rgb(${colors.text.brand.default})`}
      />
      <Text marginBottom="small">{message || t('loader.retrieving')}</Text>
      <Text>{t('loader.takeTime')}</Text>
    </VStack>
  );
};
